import { toValue, type MaybeRefOrGetter } from 'vue'

/**
 * Opens a public file URL, such as a CMS asset, in a new tab.
 * The browser requests the file itself. Reading it with fetch fails when the CMS
 * does not allow this app's origin.
 */
export function useExternalFileDownload(url: MaybeRefOrGetter<string | null | undefined>) {
  const downloadFile = (): boolean => {
    const fileUrl = toValue(url)
    if (!fileUrl) {
      return false
    }

    const link = document.createElement('a')
    link.href = fileUrl
    link.target = '_blank'
    link.rel = 'noopener noreferrer'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    return true
  }

  return { downloadFile }
}
